import { tKey } from "@/core/i18n";

/**
 * Every user-facing string of the replace-before-auto-annotating dialog, as
 * `label` catalog keys rendered with `t()`. The bodies count (staged
 * auto-annotations, conversation turns), so they are plural keys written out
 * where they render: `replaceDialog.replaceBody`, `replaceDialog.startOverBody`
 * and `replaceDialog.conversationNote` — the last appended to the replace body
 * when a Vision conversation goes with them.
 */

export const REPLACE_TITLE = tKey("label:replaceDialog.replaceTitle");
export const BUTTON_REPLACE = tKey("label:replaceDialog.replace");

export const START_OVER_TITLE = tKey("label:replaceDialog.startOverTitle");
export const BUTTON_START_OVER = tKey("label:replaceDialog.startOver");

export const BUTTON_CANCEL = tKey("common:actions.cancel");
